import * as IconSelector from '../icons';

// Constantes exportadas
export const SCOPE_MIEMBRO = 'Miembro';
export const SCOPE_USO = 'Uso';
export const SCOPE_PRODUCCION = 'Produccion';
export const SCOPE_ELABORACION = 'Elaboracion';
export const SCOPE_ALMACENAMIENTO = 'Almacenamiento';
export const SCOPE_CRIANZA = 'Crianza';
export const SCOPE_EMBOTELLADO = 'Embotellado';

// Definición del enum
export const scopes = [
    {
        value: SCOPE_MIEMBRO,
        label: 'Miembro',
        description: 'Miembro',
        icon: IconSelector.PointIcon,
        color: 'Black'
    },
    {
        value: SCOPE_USO,
        label: 'Uso',
        description: 'Uso',
        icon: IconSelector.PointIcon,
        color: 'Black'
    },
    {
        value: SCOPE_ELABORACION,
        label: 'Elaboración',
        description: 'Elaboración',
        icon: IconSelector.PointIcon,
        color: 'Black'
    },
    {
        value: SCOPE_ALMACENAMIENTO,
        label: 'Almacenamiento',
        description: 'Almacenamiento',
        icon: IconSelector.PointIcon,
        color: 'Black'
    },
    {
        value: SCOPE_CRIANZA,
        label: 'Crianza',
        description: 'Crianza',
        icon: IconSelector.PointIcon,
        color: 'Black'
    },
    {
        value: SCOPE_EMBOTELLADO,
        label: 'Embotellado',
        description: 'Embotellado',
        icon: IconSelector.PointIcon,
        color: 'Black'
    },
    {
        value: SCOPE_PRODUCCION,
        label: 'Produccion',
        description: 'Produccion',
        icon: IconSelector.PointIcon,
        color: 'Black'
    }
];
